import React from 'react';
import { MoreHorizontal } from 'lucide-react';
import { RANGES } from './constants';

const RangePicker = ({ isCustomRange, setIsCustomRange, rangeDays, setRangeDays, startDate, setStartDate, endDate, setEndDate }) => {
  if (isCustomRange) {
    return (
      <div className="flex-1 flex flex-col gap-2 bg-ink-card3 p-3 rounded-2xl border border-white/10 animate-in fade-in slide-in-from-top-1">
        <div className="flex items-center justify-between mb-1">
          <span className="text-[10px] font-mono font-medium text-ink-fg/40 uppercase tracking-wider">Custom Range</span>
          <button
            onClick={() => setIsCustomRange(false)}
            className="text-[10px] font-bold text-mint hover:text-ink-fg"
          >
            Back to Presets
          </button>
        </div>
        <div className="flex gap-2 items-center">
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className="flex-1 bg-ink-card2 border border-white/10 rounded-lg px-2 py-1.5 text-xs text-ink-fg/80 outline-none focus:ring-1 focus:ring-mint"
          />
          <span className="text-ink-fg/40 text-xs">to</span>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className="flex-1 bg-ink-card2 border border-white/10 rounded-lg px-2 py-1.5 text-xs text-ink-fg/80 outline-none focus:ring-1 focus:ring-mint"
          />
        </div>
      </div>
    );
  }

  return (
    <>
      {RANGES.map(r => (
        <button
          key={r.days}
          onClick={() => setRangeDays(r.days)}
          className={`flex-1 text-xs font-mono font-semibold py-2 px-3 rounded-xl border transition-all ${rangeDays === r.days
              ? 'bg-mint text-ink-shell border-mint shadow-sm'
              : 'bg-ink-card3 text-ink-fg/50 border-white/10 hover:border-mint/40 hover:text-mint'
            }`}
        >
          {r.label}
        </button>
      ))}
      <button
        onClick={() => setIsCustomRange(true)}
        className="p-2 text-ink-fg/40 hover:text-mint hover:bg-mint/10 rounded-xl border border-white/10 transition-all"
        title="Custom Range"
      >
        <MoreHorizontal size={18} />
      </button>
    </>
  );
};

export default RangePicker;
